<div class="confirm-dialog ups-dialog {{ dialogClass }}">
    <h2 mat-dialog-title
        *ngIf="title"
        [ngClass]="titleClass">{{ title }}</h2>
    <mat-dialog-content>
        <div class="dialog-content {{ messageClass }}"
             [innerHtml]="message"></div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button
                [mat-dialog-close]="true">
            <span class="button__content button__content__yes">{{ yes }}</span>
        </button>
        <button mat-raised-button
                class="alternative-button"
                mat-dialog-close
                tabIndex="1">
            <span class="button__content button__content__no">{{ cancel }}</span>
        </button>
    </mat-dialog-actions>
    <button type="button"
            mat-raised-button
            class="icon-button close-button"
            mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
